import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
const HomePage = lazy(() => import('../pages/home/page'));
const EligibilityPage = lazy(() => import('../pages/eligibility/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/eligibility',
    element: <EligibilityPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
